export interface ICustomizationMeshImageData {
  file: string;
}

export class CustomizationMeshImageData
implements ICustomizationMeshImageData {
  file: string = '';
}
